import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ChatUser } from "../../api/user-request";

interface ChatUsersState {
  value: ChatUser[];
}

export type UpdateChatUsersPayload = {
  id: number;
  lastMessageText: string;
  lastMessageAt: string;
};

const initialState: ChatUsersState = { value: [] };

export const chatUsersSlice = createSlice({
  name: "chatUsers",
  initialState,
  reducers: {
    setChatUsers: (state, action: PayloadAction<ChatUser[]>) => {
      state.value = action.payload;
    },
    updateLastMessage: (
      state,
      action: PayloadAction<UpdateChatUsersPayload>,
    ) => {
      const user = state.value.find(
        (user) => user.userId === action.payload.id,
      );
      if (user) {
        user.lastMessageText = action.payload.lastMessageText;
        user.lastMessageAt = action.payload.lastMessageAt;
      }
    },
  },
});

export const { setChatUsers, updateLastMessage } = chatUsersSlice.actions;
export default chatUsersSlice.reducer;
